export class RegExpRules {
    static Numbers = /^\d+$/
    static PhoneNumber_China = /^1[3-9]\d{9}$/
    static SmsCode = /^\d{4}$/
    static InviteCode = /^[\w-]{4,}$/
}